class afterhoursController {
	constructor($bookings,
	            $auth,
	            $translates,
	            $rootScope,
	            $uibModal,
	            $scope) {

		'ngInject';

		this.$bookings = $bookings;
		this.$auth = $auth;
		this.target = 'working';
		this.$rootScope = $rootScope;
		this.$scope = $scope;
	}

	$onClose($event) {
		$event.preventDefault();
		this.close({$value: 'cancel'});
	}
}


export default afterhoursController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/afterhours/afterhours.controller.js
 **/